// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--2MXgC","container":"index-module--container--1yvSq"};